export const UNDEFINED_UMPIRE_BASE_URL = new Error(
  'Please provide value for UMPIRE base API url in TisaCore.forRoot() method.',
);
